import { useContext } from 'react';

import { isPortoOperator } from '../../constants/app';
import { AppUserContext } from '../../contexts/AppUser/AppUser';

const PORTO_DOMAIN = 'porto.xyz';

const isPortoDomain = () => {
  if (typeof window === 'undefined') {
    return false;
  }
  return window.location.hostname.endsWith(PORTO_DOMAIN);
};

const hasPortoEnvOverride = () =>
  typeof process !== 'undefined' &&
  process.env.NEXT_PUBLIC_PORTO_OVERRIDE === 'true';

const useIsPortoApp = () => {
  const appUser = useContext(AppUserContext) as {
    organization?: { operator?: string };
  };
  const operator = appUser?.organization?.operator;

  // Once the user is authenticated, brand based on the operator and ignore
  // the domain the dashboard was loaded from.
  if (operator) {
    return isPortoOperator(operator);
  }

  // Pre-auth (login / enrollment): no operator is known yet, so fall back to
  // the domain (or the local env override).
  return isPortoDomain() || hasPortoEnvOverride();
};

export default useIsPortoApp;
